/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.159.0-v202606240442-CD
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqStoredTablesApiClass {
 
   constructor() {}

  /**
   * @summary Create a new stored table from CSV. The column order will be equal to the order in the CSV.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public createStoredTableFromCSV(
    body: models.StoredTableCSVInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/stored-tables/csv/create`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StoredTableOutputV1>;
  }

  /**
   * @summary Delete a column from a stored table. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the stored table
   * @param {string} columnId - The column ID to be deleted
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public deleteColumnFromStoredTable(
    {
      id,
      columnId
    } : {
      id: string,
      columnId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (columnId === null || columnId === undefined) {
      throw new Error("'columnId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/stored-tables/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{columnId}', encodeURIComponent(String(columnId)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StoredTableOutputV1>;
  }

  /**
   * @summary Delete rows from a stored table
   * @param {string} tableId - The id of the table to delete rows from
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public deleteStoredTableRows(
    body: models.StoredTableDeleteRowsInputV1,
    {
      tableId
    } : {
      tableId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (tableId === null || tableId === undefined) {
      throw new Error("'tableId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/stored-tables/${encodeURIComponent(String(tableId))}/deleteRows`
      .replace('{tableId}', encodeURIComponent(String(tableId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.DeleteRowsOutputV1>;
  }

  /**
   * @summary Get a stored table. This endpoint is experimental and may change in future releases.
   * @param {string} id - The ID of the stored table
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public getStoredTable(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/stored-tables/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StoredTableOutputV1>;
  }

  /**
   * @summary Import a CSV file that can be used to create a stored table
   * @param {Blob} [file]
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public importStoredTableCSV(
    {
      file
    } : {
      file?: File
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/stored-tables/csv`;


    const formData = new FormData();
    formData.append('file', file as File, file?.name);

    return axiosInstance.request({
      method: 'post',
      url,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      ...restOverrides
    }) as AxiosPromise<models.ImportTableCSVOutputV1>;

    return axiosInstance.request({
      method: 'post',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ImportTableCSVOutputV1>;
  }

  /**
   * @summary Modify a column in a stored table. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the stored table
   * @param {string} columnId - The column ID to be modified. Possible modifications are: changing the column&#x27;s index, renaming the column, changing the column&#x27;s type, and updating the column&#x27;s unit of measure. Once a column has become a non-String type, it&#x27;s type can not be changed.For type conversions:- String to TIMESTAMPTZ: If the string value is in ISO8601 format, it gets directly cast to a timestamp with the same information. If not, then it gets cast to the epoch timestamp.- String to Numeric: The string values will get directly converted into their numeric equivalent. So, &#x27;1&#x27; becomes 1, &#x27;1.5&#x27; becomes 1.5, 1e10 becomes 10000000000. So integers, decimals, and scientific notation is handled. If a string cannot become converted, it will be cast as null. Units of measure are parsed out of numeric values and stored separately if multiple exist. If only one unit of measure exists, it is set as the column uom.- String to Boolean: If &#x27;false&#x27;, &#x27;f&#x27;, or &#x27;0&#x27;, convert to false. If &#x27;true&#x27;, &#x27;t&#x27;, or &#x27;1&#x27;, convert to true. The string to boolean conversion is case-insensitive.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public modifyColumnInStoredTable(
    body: models.StoredTableColumnInputV1,
    {
      id,
      columnId
    } : {
      id: string,
      columnId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (columnId === null || columnId === undefined) {
      throw new Error("'columnId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/stored-tables/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{columnId}', encodeURIComponent(String(columnId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StoredTableOutputV1>;
  }

  /**
   * @summary Change the order of the columns in a storedTable. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the stored table
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public reorderColumnsInStoredTable(
    body: models.ColumnDefinitionOrderInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/stored-tables/${encodeURIComponent(String(id))}/column-order`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StoredTableOutputV1>;
  }

  /**
   * @summary Update data in a column of a stored table. This endpoint is experimental and may change in future releases.
   * @param {string} id - The Seeq ID for the stored table
   * @param {string} columnId - The column ID that the data updates are being applied to
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public updateColumnData(
    body: models.ColumnDataUpdateInputListV1,
    {
      id,
      columnId
    } : {
      id: string,
      columnId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (columnId === null || columnId === undefined) {
      throw new Error("'columnId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/stored-tables/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}/updateData`
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{columnId}', encodeURIComponent(String(columnId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.UpdatedRowsOutputV1>;
  }

  /**
   * @summary Update an existing stored table from a CSV. The column order will be equal to the order in the CSV. All existing data in the stored table will be preserved and new rows/columns from the new CSV will be added to the existing data.
   * @param {string} id - The Seeq ID for the stored table
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
  */
  public updateStoredTableFromCSV(
    body: models.StoredTableCSVInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/stored-tables/${encodeURIComponent(String(id))}/csv/update`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StoredTableOutputV1>;
  }

}


export const sqStoredTablesApi = new sqStoredTablesApiClass();

export type sqStoredTablesApiEndpoints = {
  'createStoredTableFromCSV': {
    method: 'post';
    path: '/stored-tables/csv/create';
    response: models.StoredTableOutputV1;
  };
  'deleteColumnFromStoredTable': {
    method: 'delete';
    path: '/stored-tables/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}';
    response: models.StoredTableOutputV1;
  };
  'deleteStoredTableRows': {
    method: 'post';
    path: '/stored-tables/${encodeURIComponent(String(tableId))}/deleteRows';
    response: models.DeleteRowsOutputV1;
  };
  'getStoredTable': {
    method: 'get';
    path: '/stored-tables/${encodeURIComponent(String(id))}';
    response: models.StoredTableOutputV1;
  };
  'importStoredTableCSV': {
    method: 'post';
    path: '/stored-tables/csv';
    response: models.ImportTableCSVOutputV1;
  };
  'modifyColumnInStoredTable': {
    method: 'post';
    path: '/stored-tables/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}';
    response: models.StoredTableOutputV1;
  };
  'reorderColumnsInStoredTable': {
    method: 'post';
    path: '/stored-tables/${encodeURIComponent(String(id))}/column-order';
    response: models.StoredTableOutputV1;
  };
  'updateColumnData': {
    method: 'post';
    path: '/stored-tables/${encodeURIComponent(String(id))}/columns/${encodeURIComponent(String(columnId))}/updateData';
    response: models.UpdatedRowsOutputV1;
  };
  'updateStoredTableFromCSV': {
    method: 'post';
    path: '/stored-tables/${encodeURIComponent(String(id))}/csv/update';
    response: models.StoredTableOutputV1;
  };
};

type ApiCreateStoredTableFromCSVResponse = models.StoredTableOutputV1;
type ApicreateStoredTableFromCSVMutationParams = Parameters<typeof sqStoredTablesApi.createStoredTableFromCSV> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqStoredTablesApi.createStoredTableFromCSV>;
type ApicreateStoredTableFromCSVMutationVariables = models.StoredTableCSVInputV1;

export function useApiCreateStoredTableFromCSVMutation(
  options?: Omit<UseMutationOptions<ApiCreateStoredTableFromCSVResponse, AxiosError<SeeqErrorData>,
    ApicreateStoredTableFromCSVMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateStoredTableFromCSVResponse, AxiosError<SeeqErrorData>,
  ApicreateStoredTableFromCSVMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateStoredTableFromCSVMutationVariables) =>
      sqStoredTablesApi.createStoredTableFromCSV(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDeleteColumnFromStoredTableResponse = models.StoredTableOutputV1;
type ApideleteColumnFromStoredTableMutationParams = Parameters<typeof sqStoredTablesApi.deleteColumnFromStoredTable> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqStoredTablesApi.deleteColumnFromStoredTable>;

export function useApiDeleteColumnFromStoredTableMutation(
  options?: Omit<UseMutationOptions<ApiDeleteColumnFromStoredTableResponse, AxiosError<SeeqErrorData>,
    ApideleteColumnFromStoredTableMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteColumnFromStoredTableResponse, AxiosError<SeeqErrorData>,
  ApideleteColumnFromStoredTableMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteColumnFromStoredTableMutationParams) =>
      sqStoredTablesApi.deleteColumnFromStoredTable(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiDeleteStoredTableRowsResponse = models.DeleteRowsOutputV1;
type ApideleteStoredTableRowsMutationParams = Parameters<typeof sqStoredTablesApi.deleteStoredTableRows> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqStoredTablesApi.deleteStoredTableRows>;

export function useApiDeleteStoredTableRowsMutation(
  options?: Omit<UseMutationOptions<ApiDeleteStoredTableRowsResponse, AxiosError<SeeqErrorData>,
    ApideleteStoredTableRowsMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteStoredTableRowsResponse, AxiosError<SeeqErrorData>,
  ApideleteStoredTableRowsMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApideleteStoredTableRowsMutationParams) =>
      sqStoredTablesApi.deleteStoredTableRows(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetStoredTableResponse = models.StoredTableOutputV1;
export function GetStoredTableQueryKey(
  params: Parameters<typeof sqStoredTablesApi.getStoredTable>[0],
) {
  return ['sqStoredTablesApi', 'getStoredTable', params] as const;
}

export function useApiGetStoredTableQuery(
  params: Parameters<typeof sqStoredTablesApi.getStoredTable>[0],
  options?: Omit<UseQueryOptions<ApiGetStoredTableResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetStoredTableResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetStoredTableQueryKey(params),
    queryFn: () =>
      sqStoredTablesApi.getStoredTable(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiImportStoredTableCSVResponse = models.ImportTableCSVOutputV1;
type ApiimportStoredTableCSVMutationParams = Parameters<typeof sqStoredTablesApi.importStoredTableCSV> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqStoredTablesApi.importStoredTableCSV>;

export function useApiImportStoredTableCSVMutation(
  options?: Omit<UseMutationOptions<ApiImportStoredTableCSVResponse, AxiosError<SeeqErrorData>,
    ApiimportStoredTableCSVMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiImportStoredTableCSVResponse, AxiosError<SeeqErrorData>,
  ApiimportStoredTableCSVMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiimportStoredTableCSVMutationParams) =>
      sqStoredTablesApi.importStoredTableCSV(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiModifyColumnInStoredTableResponse = models.StoredTableOutputV1;
type ApimodifyColumnInStoredTableMutationParams = Parameters<typeof sqStoredTablesApi.modifyColumnInStoredTable> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqStoredTablesApi.modifyColumnInStoredTable>;

export function useApiModifyColumnInStoredTableMutation(
  options?: Omit<UseMutationOptions<ApiModifyColumnInStoredTableResponse, AxiosError<SeeqErrorData>,
    ApimodifyColumnInStoredTableMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiModifyColumnInStoredTableResponse, AxiosError<SeeqErrorData>,
  ApimodifyColumnInStoredTableMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApimodifyColumnInStoredTableMutationParams) =>
      sqStoredTablesApi.modifyColumnInStoredTable(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiReorderColumnsInStoredTableResponse = models.StoredTableOutputV1;
type ApireorderColumnsInStoredTableMutationParams = Parameters<typeof sqStoredTablesApi.reorderColumnsInStoredTable> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqStoredTablesApi.reorderColumnsInStoredTable>;

export function useApiReorderColumnsInStoredTableMutation(
  options?: Omit<UseMutationOptions<ApiReorderColumnsInStoredTableResponse, AxiosError<SeeqErrorData>,
    ApireorderColumnsInStoredTableMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiReorderColumnsInStoredTableResponse, AxiosError<SeeqErrorData>,
  ApireorderColumnsInStoredTableMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApireorderColumnsInStoredTableMutationParams) =>
      sqStoredTablesApi.reorderColumnsInStoredTable(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateColumnDataResponse = models.UpdatedRowsOutputV1;
type ApiupdateColumnDataMutationParams = Parameters<typeof sqStoredTablesApi.updateColumnData> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqStoredTablesApi.updateColumnData>;

export function useApiUpdateColumnDataMutation(
  options?: Omit<UseMutationOptions<ApiUpdateColumnDataResponse, AxiosError<SeeqErrorData>,
    ApiupdateColumnDataMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateColumnDataResponse, AxiosError<SeeqErrorData>,
  ApiupdateColumnDataMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateColumnDataMutationParams) =>
      sqStoredTablesApi.updateColumnData(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateStoredTableFromCSVResponse = models.StoredTableOutputV1;
type ApiupdateStoredTableFromCSVMutationParams = Parameters<typeof sqStoredTablesApi.updateStoredTableFromCSV> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqStoredTablesApi.updateStoredTableFromCSV>;

export function useApiUpdateStoredTableFromCSVMutation(
  options?: Omit<UseMutationOptions<ApiUpdateStoredTableFromCSVResponse, AxiosError<SeeqErrorData>,
    ApiupdateStoredTableFromCSVMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateStoredTableFromCSVResponse, AxiosError<SeeqErrorData>,
  ApiupdateStoredTableFromCSVMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateStoredTableFromCSVMutationParams) =>
      sqStoredTablesApi.updateStoredTableFromCSV(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
